import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminMaterial: Routes = [
  {
    path: 'materiais',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'MATERIAL',
      menuKey: 'MATERIAL',
      breadcrumb: {
        label: 'Materiais',
        icon: 'mdi mdi-medication-outline'
      },
      backend_path: '/materiais'
    },
    loadChildren: () =>
      import('@app/modules/material/material.module').then(
        m => m.MaterialModule
      )
  },
  {
    path: 'ree_materiais',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'REE_MATERIAL',
      menuKey: 'REE_MATERIAL',
      breadcrumb: {
        label: 'Entrada de estoque dos materiais',
        icon: 'mdi mdi-archive-arrow-down-outline'
      },
      backend_path: '/ree_materials'
    },
    loadChildren: () =>
      import('@app/modules/entrada/entrada.module').then(m => m.EntradaModule)
  },
  {
    path: 'rse_materiais',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'RSE_MATERIAL',
      menuKey: 'RSE_MATERIAL',
      breadcrumb: {
        label: 'Saída de estoque dos materiais',
        icon: 'mdi mdi-archive-arrow-up-outline'
      },
      backend_path: '/rses_material'
    },
    loadChildren: () =>
      import('@app/modules/saida/saida.module').then(m => m.SaidaModule)
  }
];
